import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import backend from "i18next-xhr-backend";
import { reactI18nextModule } from "react-i18next";
import q from "query-string";
import translationEN from './locales/en/translation.json';
import translationTH from './locales/th/translation.json';
import translationCN from './locales/cn/translation.json';

// the translations
const resources = {
    en: {
        translation: translationEN
    },
    th: {
        translation: translationTH
    },
    cn: {
        translation: translationCN
    }
};

const queryLng = q.parse(window.location.search).language || localStorage.getItem('language')
const lng = queryLng ===  "zhCN" ? 'cn' : queryLng || 'th'

if (
    !localStorage.getItem("language") ||
    localStorage.getItem("language") === "null"
  ) {
    localStorage.setItem("language", "th");
  }

i18n
    .use(detector)
    .use(backend)
    .use(reactI18nextModule) // passes i18n down to react-i18next
    .init({
        resources,
        lng,
        fallbackLng: "th", // use en if detected lng is not available

        detection: {
            order: ["querystring", "localStorage"],
            lookupQuerystring: "language",
            lookupLocalStorage: "i18nextLng",
            caches: ["localStorage", "cookie"],
            excludeCacheFor: ["cimode"],
            cookieMinutes: 10,
          },

        // keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false // react already safes from xss
        },
        // react-i18next options
        react: {
            wait: true
        }
    });

export default i18n;